import { IApiResponse } from 'src/app/shared/interfaces/common-api.interface';

export interface ISegmentsListResponse extends IApiResponse {
  data?: ISegmentData[];
}

export interface ISegmentData {
  segmentCode: string;
  segmentName: string;
  channel: string;
  modeOfExecution: string;
  segmentType: string;
  orchestrationType?: string;
  originalMOE?: string;
  templateDetails?: ITemplate[];
  campaignBudgetInfo: ICampBudget;
  bspSubType?: string;
  bsp?: string;
}

export interface ITemplate {
  templateCode: string;
  templateName: string;
  senderId?: string;
  templateChannel: string;
  bsp?: string;
  bspSubType?: string;
  category?: string;
  shortenerProvider?: string;
}

export interface ISchedulerPayload {
  campaignCode: string;
  segmentCode: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
}

export interface ISchedulerCreateResponse extends IApiResponse {
  data?: ISchedulerResponse;
}

export interface ISchedulerResponse {
  schedulerId: string;
  message: string;
  executionTimeMs?: number;
  scheduledSlots?: {
    startTime: string;
    endTime: string;
    status: string;
  }[];
}

export interface IChannelConfig {
  type: string;
  executionDate: string;
  startTime: string;
  endTime: string;
  wabaNumber?: string;
}

export interface IWabaListResponse extends IApiResponse {
  data?: IWabaData[];
}

export interface IWabaData {
  wabaCode: string;
  wabaNumber: string;
}

export interface ISchedulerActionPayload {
  schedulerCode?: string;
  cancellationReason?: string;
  startDate?: string;
  pauseDate?: string;
  rescheduleActionRequest?: {
    startTime?: string;
    cronExp?: string;
    cronExpDesc?: string;
    frequency?: string;
    schedulerDetail?: any;
  };
}

export interface ISchedulerActionResponse extends IApiResponse {
  data?: IActionScheduler;
}

export interface IActionScheduler {
  scheduledCampaignId: string;
  message: string;
  executionTimeMs?: number;
  scheduledSlots?: {
    startTime: string;
    endTime: string;
    status: string;
  }[];
}

export enum ChannelType {
  EMAIL = 'Email',
  SMS = 'SMS',
  WHATSAPP = 'WhatsApp',
  ORCHESTRATE = 'Orchestrate',
  RCS = 'RCS',
  PUSH_NOTIFICATION = 'Push Notification',
}

export enum ChannelLevelType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum SegmentType {
  MANUAL = 'Manual',
  AUTOMATED = 'Automated',
}

export interface IEmailSenderResponse extends IApiResponse {
  data?: IEmailSender[];
}

export interface IEmailSender {
  senderId: string;
  name: string;
  code: string;
}

export interface IWabaDetailPayload {
  type: string;
  subType?: string;
  bsp?: string;
  bspSubType?: string;
}

export interface IInHouseChannelConfig {
  messageDeliveryTracking: boolean;
  linkClickTracking: boolean;
}

export interface IInHouseConfigResponse {
  error: boolean;
  data: {
    [channel: string]: IInHouseChannelConfig;
  };
}

export interface ICampBudget {
  totalBudget: number;
  reservedAmount: number;
  refundedAmount: number;
  maxBudgetPercentage: number;
}
